import { ACCOUNT_TAKEOVER_SCRIPT_SRC } from '@mews-commander/constants';
import { DataTestId, TextKey } from '@mews-commander/enums';
import { MEWS_PRIVACY_POLICY_URL } from '@mews/framework';
import { Grid, MewsLogo, Stack, StackItem } from '@optimus-web/core';
import { PlatformLink } from '../../../components';
import { LanguageSelector } from './LanguageSelector';
import { MarketingZone } from './MarketingZone';
import { ContentWrapper } from './styles';

export const AuthorizationLayout = ({ children }: React.PropsWithChildren<{}>) => (
    <Grid templateColumns="3fr 2fr" tabletMax={{ templateColumns: '1fr' }} gap="0">
        <ContentWrapper padding="700" largePhoneMax={{ padding: ['500', '300'] }}>
            <Stack vertical fill distribution="space-between" spacing="300">
                <Stack distribution="space-between" spacing="50" phoneOnly={{ vertical: true, spacing: '200' }}>
                    <MewsLogo script={ACCOUNT_TAKEOVER_SCRIPT_SRC} protectiveArea={false} />
                    <StackItem grow largePhoneUp={{ maxWidth: '200px' }}>
                        <LanguageSelector />
                    </StackItem>
                </Stack>
                <Stack alignment="center" itemAlignment="center" fill>
                    {children}
                </Stack>
                <footer>
                    <PlatformLink
                        data-test-id={DataTestId.PrivacyPolicyLink}
                        url={MEWS_PRIVACY_POLICY_URL}
                        textKey={TextKey.PrivacyPolicy}
                    />
                </footer>
            </Stack>
        </ContentWrapper>
        <MarketingZone />
    </Grid>
);
